import { useQuery } from '@tanstack/react-query';

import { errorHandler } from 'utils/errors';
import streamAPI from 'lib/api/stream';

interface StreamData {
  [key: string]: any;
}

function useGetStream(username: string) {
  const query = useQuery<StreamData>({
    queryKey: ['guestStream', username],
    queryFn: async () => {
      try {
        const response = await streamAPI.getGuestUserStream(username);

        if (!response.data) {
          throw new Error(
            'Error occurred while fetching user stream.',
          );
        }

        const { data } = response;

        return data.data;
      } catch (error) {
        errorHandler(error, 'Failed to get stream, unhandled error');
        return undefined;
      }
    },
    retry: false,
  });

  return query;
}

export default useGetStream;
